import { FC, HTMLAttributes, ReactNode, useMemo } from 'react';

import styles from './SearchPanelLi.module.css';

type SearchPanelLiProps = HTMLAttributes<HTMLLIElement> & {
  children: ReactNode;
  index: number;
  selectedListIndex?: number;
  setSelectedIndex?: React.Dispatch<React.SetStateAction<number>>;
  returnSelectedListItem?: () => void;
};
const SearchPanelLi: FC<SearchPanelLiProps> = ({
  children,
  index,
  selectedListIndex = undefined,
  setSelectedIndex = undefined,
  returnSelectedListItem = undefined,
  ...liProps
}) => {
  const isSelected = useMemo(() => index === selectedListIndex, [index, selectedListIndex]);
  const returnListItem = () => {
    if (setSelectedIndex) setSelectedIndex(index);
    if (returnSelectedListItem) returnSelectedListItem();
  };
  return (
    <li
      data-isselected={isSelected}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        returnListItem();
      }}
      className={[styles.searchPanelLi, liProps?.className ?? '', isSelected ? styles.searchPanelLiSelected : ''].join(
        ' ',
      )}
      data-testid={`search-panel-list-item-${index}`}
      {...liProps}
    >
      {children}
    </li>
  );
};
export default SearchPanelLi;
